import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Utils } from "../../../Utils";
import { Helpers } from "../../../Helpers";
import Loader from "../../Loader";
import { getSubFormListStart } from "../../../Store/Slices/subFormSlice";
import { getDashboardModuleByIdStart } from "../../../Store/Slices/dashboardComponentsSlice";

function Scorecard({ data = {}, isStatic = false }) {
  const currentOrg = useSelector((state) => state?.org);
  const { subModuleData, isDashboardLoading } = useSelector(
    (state) => state?.dashboardComponents
  );

  const dispatch = useDispatch();
  const [currentPeriodData, setCurrentPeriodData] = useState(null);
  const [countData, setCountData] = useState({});
  const [previousCountData, setPreviousCountData] = useState({});
  const [percentageChange, setPercentageChange] = useState(null);
  const [periodLabel, setPeriodLabel] = useState("This Month");
  const [previousPeriodLabel, setPreviousPeriodLabel] = useState("Previous Month");
  const [output, setOutput] = useState([]);
  const [sortedCountData, setSortedCountData] = useState({});
  const fieldValue = useSelector(
    (state) => state?.dashboardComponents?.fieldValue?.fieldValue
  );
  const subformData = useSelector((state) => state.subForm);

  const [moduleId, setModuleId] = useState(data?.moduleId);
  const formsubmodules = useSelector((state) => state?.formsubmodules);

  const [field, setField] = useState(data?.field);
  const [savedValue, setSavedValue] = useState(data?.savedValue);
  const [cfshortlistedRecords, setcfShortlistedRecords] = useState([]);
  const [pfshortlistedRecords, setpfShortlistedRecords] = useState([]);
  const [selectedField, setSelectedField] = useState(data?.selectedField);

  const fieldName = field && field.replace(/(Maximum|Minimum|Count|Sum|Average) of /g, "");

  const [cfmatchingRecords, setcfMatchingRecords] = useState([]);
  const [pfmatchingRecords, setpfMatchingRecords] = useState([]);



  useEffect(() => {
    if (data) {
      setField(data?.field);
      setSavedValue(data?.saved_value);
      setSelectedField(data?.selectedField);
    }
  }, [data]);

  useEffect(() => {
    if (data?.moduleId) {
      setModuleId(data?.moduleId);
    }
  }, [data?.moduleId]);

  useEffect(() => {
    if (moduleId) {
      // temporary commented for performance issue-dp
      // dispatch(getSubFormListStart({ page: 1, count: 10, id: moduleId }));
    }
  }, [moduleId, dispatch]);

  const getDataForPeriod = useCallback((period) => {
    const filteredData = Utils.getFilteredRecords(
      subModuleData?.[data?.moduleId],
      data?.duration1,
      period
    );
    const resultData = Utils.filteredDataGet(filteredData, data);
    return resultData.length;
  }, [subModuleData, data]);

  const getPreviousPeriod = (currentPeriod) => {
    const periodMappings = {
      'today': 'yesterday',
      'this_week': 'previous_week',
      'this_month': 'previous_month',
      'this_quarter': 'previous_quarter',
      'this_year': 'previous_year',
      'this_fiscal_year': 'previous_fiscal_year',
      'yesterday': 'today',
      'tomorrow': 'today',
      'next_week': 'this_week',
      'next_month': 'this_month',
      'next_quarter': 'this_quarter',
      'next_year': 'this_year',
      'next_fiscal_year': 'this_fiscal_year'
    };

    return periodMappings[currentPeriod] || currentPeriod;
  };

  const calculatePercentageChange = (current, previous) => {
    if (previous === 0 && current !== 0) return 100;
    if (previous !== 0) {
      return ((current - previous) / previous) * 100;
    }
    return null;
  };

  //Old Code
  // const checkCurrency = (count) => {
  //   if (/^(Sum|Minimum|Maximum|Average) of /.test(data?.field) || isStatic) {
  //     const formatter = new Intl.NumberFormat("en", {
  //       style: "currency",
  //       currency: currentOrg?.homeCurrencies?.currency_code || "USD",
  //     });
  //     return formatter.format(count);
  //   }
  //   return count;
  // };

  //New Code
  //   let checkCurrency = (countDatas) => {
  //     if (/^(Sum|Minimum|Maximum|Average) of /.test(data?.field) || isStatic) {
  //         let formatter = new Intl.NumberFormat('en', { style: 'currency', currency: (currentOrg?.homeCurrencies?.currency_code || "USD") });
  //         let valueToFormat = countDatas;
  //         if (data?.unit?.value) {
  //             valueToFormat = countDatas / data?.unit?.value;
  //         }
  //         let formattedValue = formatter.format(valueToFormat);
  //         if (data?.unit?.symbol) {
  //             formattedValue = `${formattedValue.trim()} ${data?.unit?.symbol}`;
  //         }
  //         return formattedValue.trim();
  //     } else {
  //         return countDatas;
  //     }
  // };      

  let checkCurrency = (countDatas) => {

    if (/^(Sum|Minimum|Maximum|Average) of /.test(data?.field) || isStatic) {
      // let formatter = new Intl.NumberFormat('en', { style: 'currency', currency: (currentOrg?.homeCurrencies?.currency_code || "USD") });
      let formatter;
      if (data?.field === 'currency') {
        formatter = new Intl.NumberFormat('en', { style: 'currency', currency: (currentOrg?.homeCurrencies?.currency_code || "USD") });
      } else {
        formatter = new Intl.NumberFormat('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
      let valueToFormat = countDatas;
      if (data?.unit?.value) {
        valueToFormat = countDatas / data?.unit?.value;
      }
      let formattedValue = formatter.format(valueToFormat);
      if (data?.unit?.symbol) {
        formattedValue = `${formattedValue.trim()} ${data?.unit?.symbol}`;
      }
      return formattedValue.trim();
    } else {
      return countDatas;
    }
  };


  const periodLabelMapping = {
    all: "All",
    today: "Today",
    this_week: "This Week",
    this_month: "This Month",
    this_quarter: "This Quarter",
    this_year: "This Year",
    yesterday: "Yesterday",
    previous_week: "Previous Week",
    previous_month: "Previous Month",
    previous_quarter: "Previous Quarter",
    previous_year: "Previous Year",
    tomorrow: "Tomorrow",
    next_week: "Next Week",
    next_month: "Next Month",
    next_quarter: "Next Quarter",
    next_year: "Next Year",
  };

  const processFilteredData = useCallback((currentFilteredData, previousFilteredData) => {
    const cfmatchingRecords = getMatchingRecords(currentFilteredData);
    const pfmatchingRecords = getMatchingRecords(previousFilteredData);

    setcfMatchingRecords(cfmatchingRecords);
    setpfMatchingRecords(pfmatchingRecords);

    const cfshortlistedRecords = getShortlistedRecords(cfmatchingRecords);
    const pfshortlistedRecords = getShortlistedRecords(pfmatchingRecords);

    if (cfshortlistedRecords.every((record) => record?._id && record?.name) && pfshortlistedRecords.every((record) => record?._id && record?.name)) {
      const cfShortListedRecords = cfshortlistedRecords.map((record) => record.name);
      const pfShortListedRecords = pfshortlistedRecords.map((record) => record.name);
      setcfShortlistedRecords(cfShortListedRecords);
      setpfShortlistedRecords(pfShortListedRecords);

      calculateCountData(cfShortListedRecords, pfShortListedRecords);
    } else {
      setcfShortlistedRecords(cfshortlistedRecords);
      setpfShortlistedRecords(pfshortlistedRecords);

      calculateCountData(cfshortlistedRecords, pfshortlistedRecords);
    }
  }, [selectedField, fieldName, subformData]);

  const getMatchingRecords = (filteredData) => {
    const matchingRecords = [];
    filteredData.forEach((subform) => {
      subform.data.forEach((field) => {
        const fieldName = Object.keys(field.section_data).find(
          (key) =>
            key.replace(/_/g, " ").toLowerCase() ===
            selectedField.replace(/_/g, " ").toLowerCase()
        );
        if (fieldName && field.section_data[fieldName] !== "") {
          matchingRecords.push(field);
        }
      });
    });

    return matchingRecords;

  };

  const getShortlistedRecords = (matchingRecords) => {
    return matchingRecords
      .map((record) => {
        const fieldName = Object.keys(record.section_data).find(
          (key) =>
            key.replace(/_/g, " ").toLowerCase() ===
            selectedField.replace(/_/g, " ").toLowerCase()
        );
        return record.section_data[fieldName];
      })
      .filter((value) => value !== "");
  };

  const calculateCountData = (cfshortlistedRecords, pfshortlistedRecords) => {

    const cftempOutput = {};
    const pftempOutput = {};

    if (subformData && subformData.formsubmodules) {
      const uniqueRecords = [...new Set(cfshortlistedRecords)];

      subformData.formsubmodules.forEach((submodule) => {
        const mergedSectionData = submodule.data.reduce(
          (acc, section) => ({ ...acc, ...section.section_data }),
          {}
        );



        uniqueRecords.forEach((record) => {
          const values = [
            ...(mergedSectionData.Untitled_Owner ? [mergedSectionData.Untitled_Owner.name] : []).filter((value) => {
              return value === record;
            }),
            ...(mergedSectionData ? Object.values(mergedSectionData) : []).filter((value) => {
              return value === record;
            })
          ];
          if (values.length > 0) {
            const fieldlabel = fieldName.replace(/ /g, "_");

            values.forEach((value, index) => {
              if (!cftempOutput[record]) {
                cftempOutput[record] = [];
              }
              cftempOutput[record].push({
                record: record,
                fieldName: fieldlabel,
                value: mergedSectionData[fieldlabel],
              });
            });
          }
        });
      });


      const uniqueRecordsPf = [...new Set(pfshortlistedRecords)];
      subformData.formsubmodules.forEach((submodule) => {
        const mergedSectionData = submodule.data.reduce(
          (acc, section) => ({ ...acc, ...section.section_data }),
          {}
        );

        uniqueRecordsPf.forEach((record) => {
          const values = Object.values(mergedSectionData).filter(
            (value) => value === record
          );
          if (values.length > 0) {
            const fieldlabel = fieldName.replace(/ /g, "_");

            values.forEach((value, index) => {
              if (!pftempOutput[record]) {
                pftempOutput[record] = [];
              }
              pftempOutput[record].push({
                record: record,
                fieldName: fieldlabel,
                value: mergedSectionData[fieldlabel],
              });
            });
          }
        });
      });
    }


    const calculate = (operation, label, tempOutput) => {
      const aggregates = {};
      Object.keys(tempOutput).forEach((recordType) => {
        if (Array.isArray(tempOutput[recordType])) {
          const recordValues = tempOutput[recordType]
            .filter((item) => item.fieldName === label)
            .map((item) => (item.value === "" ? 0 : parseInt(item.value)));
          if (recordValues.length > 0) {
            switch (operation) {
              case "sum":
                aggregates[recordType] = {
                  sum: recordValues.reduce((acc, val) => acc + val, 0),
                };
                break;
              case "min":
                aggregates[recordType] = {
                  min: Math.min(...recordValues),
                };
                break;
              case "max":
                aggregates[recordType] = {
                  max: Math.max(...recordValues),
                };
                break;
              case "average":
                aggregates[recordType] = {
                  average:
                    recordValues.reduce((acc, val) => acc + val, 0) /
                    recordValues.length,
                };
                break;
              case "count":
                aggregates[recordType] = {
                  count: recordValues.length,
                };
                break;
            }
          }
        }
      });

      return Object.keys(aggregates).reduce((acc, key) => {
        acc[key] = aggregates[key][operation];
        return acc;
      }, {});
    };

    const getLabel = (prefix) =>
      Helpers.replaceData(field?.replace(new RegExp(`^${prefix} of `), ""));
    if (field?.startsWith("Count of ")) {
      const label = getLabel("Count");
      setCountData(calculate("count", label, cftempOutput));
      setPreviousCountData(calculate("count", label, pftempOutput));
    } else if (field?.startsWith("Sum of ")) {
      const label = getLabel("Sum");
      setCountData(calculate("sum", label, cftempOutput));
      setPreviousCountData(calculate("sum", label, pftempOutput));
    } else if (field?.startsWith("Minimum of ")) {
      const label = getLabel("Minimum");
      setCountData(calculate("min", label, cftempOutput));
      setPreviousCountData(calculate("min", label, pftempOutput));
    } else if (field?.startsWith("Maximum of ")) {
      const label = getLabel("Maximum");
      setCountData(calculate("max", label, cftempOutput));
      setPreviousCountData(calculate("max", label, pftempOutput));
    } else if (field?.startsWith("Average of ")) {
      const label = getLabel("Average");
      setCountData(calculate("average", label, cftempOutput));
      setPreviousCountData(calculate("average", label, pftempOutput));
    }
  };

  function processCountData(countData, savedValue) {
    const [direction, limit] = savedValue.replace(/[{}]/g, "").split(" ");

    const sortedData = Object.entries(countData).sort((a, b) => {
      if (direction === "Top") {
        return b[1] - a[1];
      } else {
        return a[1] - b[1];
      }
    });

    if (direction === "Top") {
      return Object.fromEntries(sortedData.slice(0, parseInt(limit)));
    } else {
      return Object.fromEntries(sortedData.slice(0, parseInt(limit)));
    }
  }

  useEffect(() => {
    if (savedValue && Object.keys(countData).length > 0) {
      const result = processCountData(countData, savedValue);
      setSortedCountData(result);
    }
  }, [savedValue, countData]);

  useEffect(() => {
    if (
      subModuleData?.[data?.moduleId]?.length > 0 &&
      Object.keys(data)?.length > 0
    ) {
      const currentPeriodData = getDataForPeriod(data?.duration2);
      const oppositePeriod = getPreviousPeriod(data?.duration2);
      const previousPeriodData = getDataForPeriod(oppositePeriod);

      setPreviousCountData(previousPeriodData);

      const change = calculatePercentageChange(
        currentPeriodData,
        previousPeriodData
      );
      setPercentageChange(change);
      setPeriodLabel(data?.duration2);
      setPreviousPeriodLabel(oppositePeriod);

      const currentDatas = Utils.getFilteredRecords(
        subModuleData?.[data?.moduleId],
        data?.duration1,
        data?.duration2
      );

      const previousDatas = Utils.getFilteredRecords(
        subModuleData?.[data?.moduleId],
        data?.duration1,
        oppositePeriod
      );

      const currentFilteredData = Utils.filteredDataGet(currentDatas, data);
      const previousFilteredData = Utils.filteredDataGet(previousDatas, data);


      processFilteredData(currentFilteredData, previousFilteredData);
    }
  }, [subModuleData, data, getDataForPeriod, processFilteredData]);

  return (
    <>
      {isDashboardLoading && !countData ? (
        <div className="chart-loader">
          <Loader type={"infinitySpin"} isVisible={true} />
        </div>
      ) : (
        <div>
          <h6 className="card-title">{isStatic ? 'Top Lead Sources' : `Top ${data?.selectedField}`}</h6>
          <table className="table align-middle mb-0">
            <thead>
              <tr>
                <th>{data?.selectedField}</th>
                <th>{data?.field}</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(sortedCountData).map(([key, value]) => (
                <tr key={key}>
                  <td>{key}</td>
                  <td>
                    {checkCurrency(value)}
                    {percentageChange !== null && (
                      <span
                        className={`text-${percentageChange >= 0 ? "success" : "danger"
                          }`}
                        style={{ fontSize: "16px", marginLeft: "5px" }}
                      >
                        {percentageChange >= 0 ? "▲" : "▼"}{" "}
                        {Math.abs(percentageChange).toFixed(2)}%
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {isStatic && (
            <div>
              <table className="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Lead Source</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Advertisement</td>
                    <td>$550 <span className="text-success">▲ 14%</span></td>
                  </tr>
                  <tr>
                    <td>Google+</td>
                    <td>$500 <span className="text-danger">▼ 22%</span></td>
                  </tr>
                  <tr>
                    <td>Cold Call</td>
                    <td>$340 <span className="text-success">▲ 13%</span></td>
                  </tr>
                  <tr>
                    <td>Chat</td>
                    <td>$220 <span className="text-danger">▼ 19%</span></td>
                  </tr>
                  <tr>
                    <td>Twitter</td>
                    <td>$190 <span className="text-success">▲ 20%</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          <div>
            <p className="text-muted small mt-2">
              {isStatic ? '* Compared with Last year' : `* Compared with ${periodLabelMapping[previousPeriodLabel]}`}
            </p>
            <small className="text-muted">Scorecard</small>
          </div>
        </div>
      )}
    </>
  );
}

export default Scorecard;